import views from '@/views/en.json';

const en = {
  views,
};

export default en;
